export default "__VITE_ASSET__eTC2piY$__"